import type { IntegrationProvider } from '../../api'

import IntegrationCard from './IntegrationCard'

type Props = {
  integrations: IntegrationProvider[]
  onSuccess: () => void
}

const IntegrationsList = ({ integrations, onSuccess }: Props) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6">
      {integrations.map(({ id, name, logoUrl }) => (
        <IntegrationCard
          key={id}
          id={id}
          name={name}
          logoUrl={logoUrl}
          onSuccess={onSuccess}
        />
      ))}
    </div>
  )
}

export default IntegrationsList
